import { Link } from "react-router-dom";

const SuccessPageNew = () => {
  return (
   
      <div className="flex flex-col h-screen justify-center items-center">
        <div className="text-4xl text-green-600 mb-4">✔</div>
        <h2 className="text-xl font-bold mb-2 text-center">Success</h2>
<p className="text-sm text-primary text-center mb-4">
  Congratulations! Your password has been changed.
</p>
      
      
      </div>
  
  );
};

export default SuccessPageNew;